import { render, staticRenderFns } from "./quickAddClassCtr.vue?vue&type=template&id=4596179e&scoped=true"
import script from "./quickAddClassCtr.vue?vue&type=script&lang=js"
export * from "./quickAddClassCtr.vue?vue&type=script&lang=js"
import style0 from "./quickAddClassCtr.vue?vue&type=style&index=0&id=4596179e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596179e",
  null
  
)

export default component.exports